import React from "react";
import { Offcanvas } from "react-bootstrap";
import SearchableSelect from "./SearchableSelect";

const PrenotazioneAddGiornoOffcanvas = ({
    showAddPrenotazione,
    handleClosePrenotazione,
    setNewGiorno,
    newGiorno,
    tappe_all,
    strutture,
    id_prenotazione_,
    id_utente,
    users_all = [],
    token,
    insertcammino2,
    setModalError,
}) => {
    const selectedUser = users_all.find((u) => String(u.id) === String(id_utente));
    const isAgency = selectedUser && selectedUser.isAgency == 1;

    // Mirror del calcolo backend (commonAgencyBooking.js):
    // - baseCost = somma tappe fra startOrder e endOrder-1 dello stesso cammino
    // - B2B: usa costo_b2b (fallback costo); bagagli >2 → +10€ per bagaglio extra
    // - B2C: totale = baseCost * bagagli
    const B2B_QUANTITY_SURCHARGE = 10;
    function calculateTotalCost(startLocation, endLocation, baggageCount, allStages) {
        if (!startLocation || !endLocation || !baggageCount || !allStages) {
            return 0;
        }
        if (startLocation === endLocation) {
            return 0;
        }

        const startStage = allStages.find((s) => s.id == startLocation);
        const endStage = allStages.find((s) => s.id == endLocation);
        if (!startStage || !endStage) return 0;

        const camminoId = startStage.id_cammino;
        const [startOrder, endOrder] = [startStage.Ordine, endStage.Ordine].sort((a, b) => a - b);

        const baseCost = allStages.reduce((acc, stage) => {
            if (
                stage.id_cammino == camminoId &&
                stage.Ordine >= startOrder &&
                stage.Ordine <= endOrder - 1
            ) {
                const c = isAgency
                    ? (stage.costo_b2b !== null && stage.costo_b2b !== undefined ? stage.costo_b2b : stage.costo)
                    : stage.costo;
                return acc + Number(c || 0);
            }
            return acc;
        }, 0);

        if (isAgency) {
            const baggagePerPiece = Math.min(baggageCount, 2);
            const additionalBaggage = Math.max(0, baggageCount - 2);
            return baseCost * baggagePerPiece + additionalBaggage * B2B_QUANTITY_SURCHARGE;
        }
        return baseCost * baggageCount;
    }



    const handleAddGiorno = async () => {
        await setModalError(false);
        if (isAgency && Number(newGiorno.bagagli) < 2) {
            setModalError("Per le prenotazioni agenzia il numero minimo di bagagli è 2.");
            return;
        }
        let resultInsert = await insertcammino2(
            token,
            newGiorno.tappa_inizio,
            newGiorno.tappa_fine,
            calculateTotalCost(newGiorno.tappa_inizio, newGiorno.tappa_fine, newGiorno.bagagli, tappe_all),
            newGiorno.data,
            newGiorno.alloggio_ritiro,
            newGiorno.alloggio_consegna,
            newGiorno.bagagli,
            3, // Default status (In Attesa)
            id_prenotazione_,
            id_utente,
            newGiorno.nome_tappa_inizio,
            newGiorno.nome_tappa_fine
        );

        if (resultInsert.status == 200) {
            handleClosePrenotazione();
            window.location.reload();
        } else {
            await setModalError(resultInsert.data);
        }
    };

    return (
        <Offcanvas
            className="offcanvas-custom"
            placement="end"
            show={showAddPrenotazione}
            onHide={handleClosePrenotazione}
        >
            <Offcanvas.Header>
                <img
                    onClick={handleClosePrenotazione}
                    className="btn-close-img"
                    src="/closeBtn.svg"
                />
                <p
                    style={{
                        color: "#B1B1B1",
                        fontSize: "2em",
                        marginBottom: "0",
                        position: "absolute",
                        left: "60px",
                    }}
                >
                    Prenotazioni - Aggiungi
                </p>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
                    <div>
                        <div>
                            <div>
                                <h1
                                    style={{
                                        fontSize: "1.3em",
                                        fontWeight: "700",
                                        marginBottom: "40px",
                                        marginTop: "30px",
                                    }}
                                >
                                    Aggiungi Prenotazione
                                </h1>
                            </div>

                            <div>
                                <div className="md-form mb-2">
                                    <i className="fas fa-user prefix grey-text"></i>

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Data
                                    </label>
                                    <input
                                        onChange={async (e) => {
                                            await setNewGiorno({
                                                ...newGiorno,
                                                data: e.target.value,
                                            })
                                        }}
                                        type="date"
                                        id="orangeForm-name"
                                        className="form-control validate"
                                    />

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Tappa d'inizio
                                    </label>

                                    <SearchableSelect
                                        options={tappe_all}
                                        value={newGiorno.tappa_inizio}
                                        getLabel={(t) => `${t.id} - ${t.nome}`}
                                        getValue={(t) => t.id}
                                        placeholder="Cerca una tappa..."
                                        onSelect={(t) =>
                                            setNewGiorno({
                                                ...newGiorno,
                                                tappa_inizio: t.id,
                                                nome_tappa_inizio: t.nome,
                                            })
                                        }
                                    />

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Tappa di fine
                                    </label>
                                    <SearchableSelect
                                        options={tappe_all}
                                        value={newGiorno.tappa_fine}
                                        getLabel={(t) => `${t.id} - ${t.nome}`}
                                        getValue={(t) => t.id}
                                        placeholder="Cerca una tappa..."
                                        onSelect={(t) =>
                                            setNewGiorno({
                                                ...newGiorno,
                                                tappa_fine: t.id,
                                                nome_tappa_fine: t.nome,
                                            })
                                        }
                                    />

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Struttura di ritiro
                                    </label>
                                    <SearchableSelect
                                        options={strutture.filter(
                                            (s) => s.id_tappa == newGiorno.tappa_inizio && s.attivo == 0
                                        )}
                                        value={newGiorno.alloggio_ritiro}
                                        getLabel={(a) => `${a.id} - ${a.nome}`}
                                        getValue={(a) => a.id}
                                        placeholder={
                                            newGiorno.tappa_inizio
                                                ? "Cerca un alloggio..."
                                                : "Seleziona prima la tappa d'inizio"
                                        }
                                        disabled={!newGiorno.tappa_inizio}
                                        onSelect={(a) =>
                                            setNewGiorno({
                                                ...newGiorno,
                                                alloggio_ritiro: a.id,
                                            })
                                        }
                                    />

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Struttura di consegna
                                    </label>
                                    <SearchableSelect
                                        options={strutture.filter(
                                            (s) => s.id_tappa == newGiorno.tappa_fine && s.attivo == 0
                                        )}
                                        value={newGiorno.alloggio_consegna}
                                        getLabel={(a) => `${a.id} - ${a.nome}`}
                                        getValue={(a) => a.id}
                                        placeholder={
                                            newGiorno.tappa_fine
                                                ? "Cerca un alloggio..."
                                                : "Seleziona prima la tappa di fine"
                                        }
                                        disabled={!newGiorno.tappa_fine}
                                        onSelect={(a) =>
                                            setNewGiorno({
                                                ...newGiorno,
                                                alloggio_consegna: a.id,
                                            })
                                        }
                                    />

                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Numero Bagagli{isAgency ? " (minimo 2)" : ""}
                                    </label>
                                    <input
                                        onChange={async (e) => {
                                            await setNewGiorno({
                                                ...newGiorno,
                                                bagagli: e.target.value,
                                            })
                                        }}
                                        type="number"
                                        min={isAgency ? 2 : 1}
                                        id="orangeForm-name"
                                        className="form-control validate"
                                    />
                                    <label
                                        data-error="wrong"
                                        data-success="right"
                                        htmlFor="orangeForm-name"
                                    >
                                        Costo
                                    </label>
                                    {calculateTotalCost(newGiorno.tappa_inizio, newGiorno.tappa_fine, newGiorno.bagagli, tappe_all)}

                                </div>
                            </div>

                            <div className="modal-footer d-flex justify-content-center">
                                <button
                                    onClick={handleAddGiorno}
                                    className="btn btn-deep-orange close btn-update"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Inserisci Prenotazione
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default PrenotazioneAddGiornoOffcanvas;